import { z } from 'zod'

export const attributesFlexSchema = z.object({
  row: z.boolean().optional(),
  column: z.boolean().optional(),
  grow: z.number().optional(),
  align: z.enum(['start', 'center', 'end']).optional(),
  justify: z.enum(['start', 'center', 'end']).optional(),
})

export type AttributesFlex = z.infer<typeof attributesFlexSchema>
